import { shadowsNone, shadowsBase, shadowsMd, shadowsLg, shadowsAlt, } from "@airhelp/design-tokens";
const shadows = {
    none: shadowsNone,
    base: shadowsBase,
    md: shadowsMd,
    lg: shadowsLg,
    alt: shadowsAlt,
};
export default shadows;
